module.exports = __webpack_public_path__ + "img/Group.bce679be.png";